export default {
  API_ENDPOINT: 'https://agile-earth-34735.herokuapp.com/',
  TOKEN_KEY: process.env.REACT_APP_TOKEN_KEY,
}
